import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = process.env.REACT_APP_B2B_API_BASE_URL;

//Fetching Company List Api
export const fetchCompanyApi = async (payload) => {
  
  let url = "";
  const payloadData = {
    search: payload?.companyData?.search || '',
    status: payload?.companyData?.status || '',
    userCity: payload?.companyData?.location || '',
    pageSize: payload?.companyData?.pageSize || '',
    dateFrom: payload?.companyData?.dateFrom || '',
    dateTo: payload?.companyData?.dateTo || '',
  };

  const page = payload?.companyData?.page === 0 || payload?.companyData?.page ? payload?.companyData?.page + 1 : 1;

  if(payload?.companyData?.companyType){
    url = `${env}${API_ENDPOINT.Company.api}?search=${payloadData?.search}&companyType=${"SubCompany&page"}=${page}&status=${payloadData?.status}&userCity=${payloadData?.userCity}&pageSize=${payloadData?.pageSize}&dateTo=${payloadData?.dateTo}&dateFrom=${payloadData?.dateFrom}`
  } 
  else if (payload?.searchKey?.searchType){
    url =`${env}${API_ENDPOINT.Company.api}?search=${payloadData?.search}&companySearch=true`
  }
  else {
    url =`${env}${API_ENDPOINT.Company.api}?search=${payloadData?.search}&page=${page}&status=${payloadData?.status}&userCity=${payloadData?.userCity}&pageSize=${payloadData?.pageSize}&dateTo=${payloadData?.dateTo}&dateFrom=${payloadData?.dateFrom}`
  }

  const res = await requestInstance
    .get(url)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Company Profile
export const fetchCompanyProfile = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Company.api + '/' + data.id}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Parent Company
export const fetchParentCompanyList = async (payload) => {
  let url = "";
  const payloadData = {
    search: payload?.companyData?.search || '',
    page: payload?.companyData?.page === 0 || payload?.companyData?.page ? payload?.companyData?.page + 1 : 1
  };

 if (payload?.searchKey?.searchType){
    url =`${env}${API_ENDPOINT.Company.api}?type=parent&search=${payloadData?.search}&companySearch=true`
  }
  else {
    url =`${env}${API_ENDPOINT.Company.api}?type=parent&pageSize=200&status=Active`
  }

  const res = await requestInstance
    .get(url)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Onboarding Api Endpoint
export const addCompanyApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Company.onboardingDetails}`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//OnBoard GSTDetails Api Endpoint

export const addGstCompanyApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Company.gstDetailsApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Update Onboarding Api Endpoint
export const updateCompanyApi = async (data) => {
  const id = data.get('id');
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Company.onboardingDetails + '/' + id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Update GSTDetails Api Endpoint

export const updateGstCompanyApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Company.gstDetailsApi + '/' + data?.id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Update Company Domain Api Endpoint
export const updateCompanyDomainApi = async (companyId, clientUrl) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Company.updateCompanyDomainApi}/${companyId}`, {
      clientUrl: clientUrl
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Update Company Status Api Endpoint
export const updateCompanyStatusApi = async (companyId, status) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Company.updateCompanyStatusApi}/${companyId}`, {
      status: status
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Delete Company Api Endpoint
export const deleteCompanyApi = async (companyId) => {
  const res = await requestInstance
    .delete(`${env}${API_ENDPOINT.Company.api + '/' + companyId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//ParentCompany Details
export const fetchParentCompanyDetails = async (data) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.ParentCompanyDetails.api + '/' + data.id}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};